module.exports = __webpack_public_path__ + "media/images/editorial_board_icons/eb_ross_sm-db9f393ddba640f7b9525568754a6590.png";